import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import ProductGroupsListPage from './Features/ProductGroupsList'

const ProductGroupsPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'Product', 'productGroup') ? (
            <ProductGroupsListPage />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default ProductGroupsPage
